import React from "react";
import styled from "styled-components";
import AbsLogo from "../assets/abs-logo.png";
import TmobAbsLogo from "../assets/abs_small_logo.svg";
import { ConfigurationRenderProps } from "./StrikeZoneRender";

type ImgProps = {
  width: number;
  bottom: number;
  left: number;
};

const Img = styled.img<ImgProps>`
  position: absolute;
  width: ${(props) => props.width + "px"};
  bottom: ${(props) => props.bottom + "px"};
  left: ${(props) => props.left + "px"};
  z-index: 2;
`;

const SHOW_TMOB = process.env.SHOW_TMOB === "true";

const LeftLogo: React.FC<ConfigurationRenderProps> = ({ config }) => {
  const width = 155 * config.scaling.multiplier;
  const bottom = config.display.displayAddtlInfo
    ? (SHOW_TMOB ? 130 : 120) * config.scaling.multiplier
    : (SHOW_TMOB ? 130 : 120) * config.scaling.multiplier;
  const left = config.scaling.multiplier;
  return <Img src={SHOW_TMOB ? TmobAbsLogo : AbsLogo} width={width} bottom={bottom} left={left} />;
};

export default LeftLogo;
